<template>
  <BaseLightBox :boxNumber="4" mode="orders">
    <template #title>
      <span>מסמכים</span>
    </template>
    <ul class="invoices Heebo">
      <BaseInvoice
        v-for="invoice in invoices"
        :key="invoice.docno"
        :invoice="invoice"
        @download-invoice="downloadInvoice"
      />
    </ul>
  </BaseLightBox>
</template>

<script>
import BaseInvoice from "./BaseInvoice.vue";
import BaseLightBox from "../UI/BaseLightBox.vue";
export default {
  components: { BaseInvoice, BaseLightBox },
  name: "Invoices",
  props: {
    invoices: {
      type: Array,
      required: true,
    },
  },
  methods: {
    async downloadInvoice(docId) {
      await this.$store.dispatch('Invoices/delevires', docId);
    },
  },
};
</script>

<style scoped lang="scss">
.invoices {
  list-style: none;
  border-radius: 30px;
  padding: 5px 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
</style>
